import React, { useState } from "react";
import { Button, Col, Divider, Form, Modal, Row } from "antd";
import { Link, useHistory } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../../..";
import { TypesCharacteristicsCreateContext } from "../../context/TypesCharacteristicsCreateContext/TypesCharacteristicsCreateContext";
import { ITypesCharacteristicsCreateContext } from "../../context/TypesCharacteristicsCreateContext/types";
import { TypesCharacteristicsParams } from "../../features/TypesCharacteristicsParams/TypesCharacteristicsParams";
import { TypesCharacteristicsValues } from "../../features/TypesCharacteristicsValues/TypesCharacteristicsValues";
import "./TypesCharacteristicsCreate.less";
import { ITypesCharacteristicsValuesTableRecord } from "../../features/TypesCharacteristicsValues/utils/types";
import { createTypesCharacteristics } from "../../store/slice/typesCharacteristicsSlice";
import { ITypesCharacteristicsCreateParams } from "../../types/TypesCharacteristicsCreateParams";
import {
  checkIsLoading,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../../../lib/utils";

export const TypesCharacteristicsCreate = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const { createTypesCharacteristicsLoading } = useAppSelector(
    (state) => state.typesCharacteristics
  );

  const [typesCharacteristicsParamsForm] = Form.useForm();

  const contextValue: ITypesCharacteristicsCreateContext = {};

  const [tableData, setTableData] = useState<ITypesCharacteristicsValuesTableRecord[]>([]);

  const [selectedDataTypeId, setSelectedDataTypeId] = useState(undefined);

  const onChangeDataTypeId = (value) => {
    if (tableData.length > 0) {
      Modal.confirm({
        title: "Тип данных изменен",
        content: "Значения Типов характеристик будут очищены. Пожалуйста подтвердите изменения.",
        okText: "Подтвердить",
        onOk: () => {
          setSelectedDataTypeId(value);
          typesCharacteristicsParamsForm.setFieldsValue({
            dataTypeId: value,
            valueTypeId: 1,
            specificDicTypeAlias: undefined,
            valueDicTypeAlias: undefined,
          });
          setTableData([]);
        },
        onCancel() {
          setSelectedDataTypeId((prev) => {
            typesCharacteristicsParamsForm.setFieldsValue({
              dataTypeId: prev,
              specificDicTypeAlias: undefined,
              valueDicTypeAlias: undefined,
            });
            return prev;
          });
        },
      });
    } else {
      setSelectedDataTypeId(value);
      typesCharacteristicsParamsForm.setFieldsValue({
        dataTypeId: value,
        specificDicTypeAlias: undefined,
        valueDicTypeAlias: undefined,
      });
    }
  };

  const [selectedValueTypeId, setSelectedValueTypeId] = useState<number | undefined>(undefined);

  const onReset = () => {
    setSelectedDataTypeId(undefined);
    setSelectedValueTypeId(undefined);
    typesCharacteristicsParamsForm.resetFields();
    setTableData([]);
  };

  const onFinish = (fields) => {
    const params: ITypesCharacteristicsCreateParams = {
      name: fields.name,
      dataTypeId: Number(fields.dataTypeId),
      dsc: fields?.dsc,
      alias: fields?.alias,
      minCardinality: fields?.minCardinality !== undefined ? fields?.minCardinality : undefined,
      maxCardinality: fields?.maxCardinality !== undefined ? fields?.maxCardinality : undefined,
      specificDicTypeAlias: fields?.specificDicTypeAlias,
      valueDicTypeAlias: fields?.valueDicTypeAlias,
    };

    if (fields.dataTypeId !== 4 && fields.dataTypeId !== 3) {
      params.charTypeValues = tableData.map((item) => {
        return {
          valueTypeId: Number(fields.valueTypeId),
          unitTypeId: Number(fields[`${item.key}_unitTypeId`]) || undefined,
          rangeTypeId: Number(fields[`${item.key}_rangeTypeId`]) || undefined,
          value: fields[`${item.key}_value`],
          valueTo: fields[`${item.key}_valueTo`],
        };
      });
    }

    if (fields.dataTypeId === 3) {
      params.charTypeValues = tableData.map((item) => {
        return {
          valueTypeId: Number(fields.valueTypeId),
          unitTypeId: Number(fields[`${item.key}_unitTypeId`]) || undefined,
          rangeTypeId: Number(fields[`${item.key}_rangeTypeId`]) || undefined,
          value: toHttpFormatStartOfDay(fields[`${item.key}_value`]),
          valueTo: fields[`${item.key}_valueTo`]
            ? toHttpFormatEndOfDay(fields[`${item.key}_valueTo`])
            : undefined,
        };
      });
    }

    if (fields.dataTypeId === 4) {
      const charTypeValuesFormat: ITypesCharacteristicsCreateParams["charTypeValues"] = [];

      tableData.forEach((item) => {
        if (Number(fields.valueTypeId) === 1) {
          if (Array.isArray(fields[`${item.key}_value`])) {
            fields[`${item.key}_value`].forEach((value) => {
              charTypeValuesFormat.push({
                valueTypeId: Number(fields.valueTypeId),
                unitTypeId: Number(fields[`${item.key}_unitTypeId`]) || undefined,
                rangeTypeId: Number(fields[`${item.key}_rangeTypeId`]) || undefined,
                value,
              });
            });
          }
        } else {
          charTypeValuesFormat.push({
            valueTypeId: Number(fields.valueTypeId),
            unitTypeId: Number(fields[`${item.key}_unitTypeId`]) || undefined,
            rangeTypeId: Number(fields[`${item.key}_rangeTypeId`]) || undefined,
            value: fields[`${item.key}_value`],
            valueTo: fields[`${item.key}_valueTo`],
          });
        }
      });

      params.charTypeValues = charTypeValuesFormat;
    }

    dispatch(createTypesCharacteristics(params)).then((res) => {
      if (res?.payload?.id) {
        setTimeout(() => {
          onReset();
          history.push(`/types-characteristics/${res?.payload?.id}`);
        }, 1000);
      }
    });
  };

  return (
    <TypesCharacteristicsCreateContext.Provider value={contextValue}>
      <div className="types-characteristics-create">
        <Row className="types-characteristics-create-title" align="middle">
          <Link to="/types-characteristics">
            <LeftOutlined style={{ fontSize: 16 }} />
          </Link>

          <h1>Создание типа характеристики</h1>

          <Divider className="types-characteristics-create-divider" />
        </Row>

        <Form
          form={typesCharacteristicsParamsForm}
          onFinish={onFinish}
          labelAlign="left"
          initialValues={{
            contextId: 1,
            statusId: 0,
          }}
          style={{ width: "100%" }}
        >
          <TypesCharacteristicsParams
            mode="create"
            typesCharacteristicsParamsForm={typesCharacteristicsParamsForm}
            onChangeDataTypeId={onChangeDataTypeId}
            selectedDataTypeId={selectedDataTypeId}
          />

          <Divider
            className="types-characteristics-create-divider"
            style={{ marginTop: "-10px", marginBottom: 0 }}
          />

          <TypesCharacteristicsValues
            mode="create"
            tableData={tableData}
            setTableData={setTableData}
            typesCharacteristicsParamsForm={typesCharacteristicsParamsForm}
            selectedValueTypeId={selectedValueTypeId}
            setSelectedValueTypeId={setSelectedValueTypeId}
          />
        </Form>

        <Row align="middle" style={{ paddingTop: "10px" }} justify="center">
          <Col
            span={24}
            style={{
              textAlign: "center",
            }}
          >
            <Button
              style={{
                margin: "0 8px",
              }}
              onClick={() => {
                history.push(`/types-characteristics`);
                typesCharacteristicsParamsForm.resetFields();
              }}
            >
              Отмена
            </Button>
            <Button
              type="primary"
              onClick={() => {
                typesCharacteristicsParamsForm.submit();
              }}
              loading={checkIsLoading(createTypesCharacteristicsLoading)}
            >
              Сохранить
            </Button>
          </Col>
        </Row>
      </div>
    </TypesCharacteristicsCreateContext.Provider>
  );
};
